<template>
  <div>
    <v-row dense align="center">
      <v-col cols="12" sm="9" class="text-truncate">
        <px-situacao-cotacao-icon :situacao="cotacao.situacao"/>
        {{ cotacao.identificador }}
      </v-col>
      <v-col cols="12" sm="3" class="text-right">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon link
                   v-on="on"
                   :disabled="!isAberta"
                   :to="linkEdicao">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Editar cotação</span>
        </v-tooltip>
        <px-cancelamento-cotacao-frete-button :disabled="!isAberta"
                                              :cotacao="cotacao"
                                              @cancelada="emitUpdate"/>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" class="caption">
        <v-icon>mdi-domain</v-icon>
        {{ cotacao.company.pessoa.nome }} ({{ cotacao.company.pessoa.cnpj | cnpj }})
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" class="caption">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon class="mr-2">mdi-map-marker-multiple</v-icon>
            <span v-on="on">
              {{ cotacao.municipioColeta.nome }}
              ({{ cotacao.municipioColeta.estado.sigla }})
            </span>
          </template>
          <span>
            Município de coleta
          </span>
        </v-tooltip>
        <v-icon class="mx-5">mdi-arrow-right</v-icon>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              {{ cotacao.municipioEntrega.nome }}
              ({{ cotacao.municipioEntrega.estado.sigla }})
            </span>
          </template>
          <span>
            Município de entrega
          </span>
        </v-tooltip>
      </v-col>
    </v-row>
  </div>

</template>

<script>
import { SituacaoCotacao } from 'px-business-components';
import CancelamentoCotacaoFreteButton from '../cancelamento/CancelamentoCotacaoFreteButton.vue';

export default {
  props: {
    cotacao: Object,
  },
  computed: {
    isAberta() {
      return SituacaoCotacao.keys.ABERTA.key === this.cotacao.situacao;
    },
    linkEdicao() {
      return `/edicao-cotacao-frete/${this.cotacao.id}`;
    },
  },
  methods: {
    emitUpdate() {
      this.$emit('update');
    },
  },
  components: {
    pxCancelamentoCotacaoFreteButton: CancelamentoCotacaoFreteButton,
  },
};
</script>
